import { dashboard } from './dashboard.router'
import { journal } from './journal.router'
import { attendance } from './attendance.router'
import { families } from './families.router'
import { staff } from './staff.router'
import { communicate } from './communicate.router'
import { learn } from './learn.router'
import { finances } from './finances.router'
import { reports } from './reports.router'
import { setup } from './setup.router'
import { superAdmin } from './super-admin.router'
import { settings } from './settings.router'
import { developer } from './developer.router'

export const modules = [
  dashboard,
  attendance,
  families,
  staff,
  journal,
  communicate,
  learn,
  finances,
  reports,
  setup,
  superAdmin,
  settings,
  developer,
]
